module.exports = __webpack_public_path__ + "img/application_submitted.6bc51522.svg";